export default {
  onGps: (state) => state.driverInfo.onGps,
  driverInfo: (state) => state.driverInfo.info,
}



// WEBPACK FOOTER //
// ./src/store/hailState/getters.js